// extracted by mini-css-extract-plugin
var _1 = "PUKADf2OOj";
export { _1 as "screen" }
